import React from "react";
import ct from "class-types.macro";

type SelectProps = React.DetailedHTMLProps<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
>;

const newSelect = (props: SelectProps) => {
  const { children } = props;

  return (
    <select
      className={ct(
        "appearance-none",
        "bg-none",
        "border-gray-400",
        "rounded",
        "border-solid",
        "border",
        "box-border",
        "p-0",
        "pl-2",
        "pr-10",
        "relative",
        "inset-0",
      )}
      {...props}
    >
      {children}
    </select>
  );
};

export default newSelect;
